<template>
    <sections>
        <app-subheader title="Event" :parent="{title: 'Home', route: '/'}" :dark="true">
            <button-subheader
                v-if="isAdmin && event"
                buttonIcon="edit"
                buttonText="Edit"
                :buttonHref="$config.public.admin.event + event.id_event"
                :dark="true"
            ></button-subheader>
        </app-subheader>
        <section-image
            v-if="event"
            color="bg-zinc-800"
            padding="py-8 sm:py-12"
            :image="$config.public.images + event.event_image"
            image-aspect-ratio="aspect-[40/21]"
            :heading="event.event_title"
            headingColor="text-zinc-100"
            :content="event.event_excerpt"
            contentColor="text-zinc-300"
            buttonText="Venue Details"
            buttonRoute="/venue"
        ></section-image>
        <section-text v-if="event" padding="pt-8 sm:pt-12">
            <template v-slot:custom>
                <button-primary
                    v-if="event.event_slug === 'west-coast-swing-classes-leeds'"
                    buttonIcon="refresh"
                    buttonText="Subscribe & Save"
                    buttonRoute="/subscribe"
                ></button-primary>
                <form-event-interest v-else></form-event-interest>
            </template>
        </section-text>
        <section-text
            v-if="event"
            padding="py-8 sm:pt-10 sm:pb-16"
            :content="event.event_description || '<p>More details coming soon.</p>'"
        ></section-text>
        <loading-spinner v-if="event === null && !error"></loading-spinner>
    </sections>
</template>

<script setup>
const eventSlug = useRoute().params.eventSlug;

const {isAdmin} = storeToRefs(useStoreAuth());

const {event, error} = storeToRefs(useStoreEvent());
const {getEvent} = useStoreEvent();

await useLazyAsyncData('getEvent' + eventSlug, () => getEvent(eventSlug).then(() => true));

useSeoEvent().buildReactiveHead(event, error);
</script>
